import type {CSSObject} from '@mantine/core';

/**
 * レスポンシブ対応のDrawerサイズを取得
 * PC: 最大800px（画面幅800px以下では画面幅に合わせる）
 * SP: 100%
 * @param isSp - SPモードかどうか
 * @returns Drawerのサイズ値
 */
export const getDrawerSize = (isSp: boolean): string | number => {
  return isSp ? '100%' : 800;
};

/**
 * 共通のDrawerスタイル定義
 * タイトルを太字にし、コンテンツを縦方向に伸縮可能にする
 */
export const COMMON_DRAWER_STYLES: {
  title: CSSObject;
  content: CSSObject;
  body: CSSObject;
} = {
  title: {
    fontWeight: 'bold',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  body: {
    flex: 1,
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
};

/**
 * 内部コンテンツにスクロールを委譲するDrawerスタイル
 * ProgressDetailDrawerなど、内部に独自のスクロールエリアを持つ場合に使用
 */
export const DRAWER_STYLES_WITH_INTERNAL_SCROLL: {
  title: CSSObject;
  content: CSSObject;
  body: CSSObject;
} = {
  title: {
    fontWeight: 'bold',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  body: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
};

/**
 * タイトルの幅を100%にする拡張スタイル
 * EventDetailModalなど、タイトルエリアにボタンを配置する場合に使用
 */
export const DRAWER_STYLES_WITH_FULL_WIDTH_TITLE: {
  title: CSSObject;
  content: CSSObject;
  body: CSSObject;
} = {
  title: {
    width: '100%',
    fontWeight: 'bold',
    marginRight: '8px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  body: {
    flex: 1,
    overflow: 'auto',
  },
};
